export interface AuthState {
  isSignedIn: boolean;
  userType: UserType | undefined;
  role: UserRole | undefined;
  domain: string | undefined;
  nextStep: string;
  user: any | undefined;
  temporaryData?: {
    username?: string;
    signUpPassword?: string;
    sharedSecret?: string;
    setupUri?: string;
  };
}

export enum UserType {
  STUDENT = "STUDENT",
  PROVIDER = "PROVIDER",
  PARTNER = "PARTNER",
  EDUBAY = "EDUBAY",
}

export enum UserRole {
  SUPERADMIN = "SuperAdmin",
  SUPPORT = "Support",
  OWNER = "Owner",
  ADMIN = "Admin",
  MEMBER = "Member",
}

export enum UserStatus {
  PENDING = "PENDING",
  CONFIRMED = "CONFIRMED",
  DISABLED = "DISABLED",
}

export interface AccessRole {
  domain: string;
  email: string;
  userType: Exclude<UserType, UserType.STUDENT>;
  role: UserRole;
  status: UserStatus;
  lastLoggedIn: string | null;
  readonly createdAt: string;
  readonly updatedAt: string;
}
